import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";
import { createPortal } from "react-dom";

export type ToastTone = "success" | "error" | "info";

export function Toast({ message, tone, onDismiss, className }: {
  className?: string;
  message: string;
  tone: ToastTone;
  onDismiss?: () => void;
}) {
  if (!message) return null;
  const Icon = tone === "error" ? AlertCircle : tone === "success" ? CheckCircle2 : Info;
  const content = (
    <div className={`toast ${tone}${className ? ` ${className}` : ""}`} role={tone === "error" ? "alert" : "status"} aria-atomic="true">
      <Icon className="toast-icon" size={20} aria-hidden="true" />
      <span className="toast-message">{message}</span>
      {onDismiss ? (
        <button type="button" className="toast-dismiss" aria-label="Bildirimi kapat" onClick={onDismiss}>
          <X size={18} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
  return typeof document === "undefined" ? content : createPortal(content, document.body);
}
